import { useParams } from "react-router-dom";
import { useReadingEmail } from "./useReadingEmail";

export function useEmailId() {
  const { emailId } = useParams<{ emailId: string }>();
  const { emailId: readingEmailId } = useReadingEmail();

  return emailId || readingEmailId;
}
